import { useContext } from 'react';
import { AppDataContext, AppDataContextType } from '../contexts/AppdataContext';

export const useAppData = (): AppDataContextType => useContext(AppDataContext);
